import axios from '@lib/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export interface Inputs {
  file: any;
}

interface ImportCompanyRecipientsProps {
  companyId: string;
	onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useImportCompanyRecipients = ({
  companyId,
	onSuccess,
  onError
}: ImportCompanyRecipientsProps) => {
  const queryClient = useQueryClient();

	const {
		isPending,
		isError,
		error,
		mutate: onImportCompanyRecipients,
	} = useMutation({
		mutationFn: async (data: Inputs) => {
      return axios.post('/recipients/import', { ...data, companyId }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
		},
		onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['company', companyId] });
      if (onSuccess)
        onSuccess(data);
    },
    onError
	});

	return { onImportCompanyRecipients, isPending, isError, error };
};
